<template>
    <modal :cancel-button-text="$t('MODAL_UNDERSTOOD')" class="text-center" custom-class="max-w-lg">
        <p>
            {{ $t('HOLIDAY_CANCELLATION_MODAL_NEXT_DELIVERY') }}
            <br><em><strong v-text='nextDeliveryDay'></strong></em>
        </p>
        <p v-html="$t('HOLIDAY_CANCELLATION_MODAL_LONGER_BREAK', {contactNumber})"></p>
    </modal>
</template>

<script>
import * as moment from 'moment';
import Modal from '@/components/structure/Modal';

export default {
    name: 'HolidayCancellationModal',
    components: {
        Modal,
    },
    data() {
        return {
            modalFormatDate: 'dddd, Do of MMMM',
            contactNumber: process.env.VUE_APP_TELEPHONE,
        };
    },
    computed: {
        deliveryDays() {
            return this.$store.getters['scheduledOrder/getDeliveryDays'];
        },
        holidays() {
            return this.$store.getters['scheduledOrder/getHolidays'];
        },
        holidaysNumberString() {
            return this.holidays.length === 4 ? 'four' : 'five';
        },
        nextDeliveryDay() {
            return moment(this.$store.getters['subscription/getNextAvailableDeliveryDate']).format(this.modalFormatDate);
        },
        today() {
            return this.$store.getters['scheduledOrder/getToday'];
        },
    },
};
</script>
